// Import Dependencies
import { Navigate, useOutlet } from "react-router";

// Local Imports
import { useAuthStore } from "@/store/useAuthStore";
import { HOME_PATH, REDIRECT_URL_KEY } from "@/constants/app";

// ----------------------------------------------------------------------

export default function GhostGuard() {
  const outlet = useOutlet();
  const { isAuthenticated } = useAuthStore();

  const redirectParam = new URLSearchParams(window.location.search).get(
    REDIRECT_URL_KEY,
  );
  const url = redirectParam ?? "";

  if (isAuthenticated) {
    // Avoid redirecting to literal "null" or empty values
    if (url && url !== "null") {
      return <Navigate to={url} />;
    }
    return <Navigate to={HOME_PATH} />;
  }

  return <>{outlet}</>;
}
